import React from 'react';
export function useSwipe(opts) {
    const startX = React.useRef(0);
    const startY = React.useRef(0);
    const dx = React.useRef(0);
    const dy = React.useRef(0);
    const active = React.useRef(false);
    const threshold = opts.threshold ?? 48;
    const onTouchStart = (e) => {
        if (e.touches.length !== 1)
            return;
        const t = e.touches[0];
        startX.current = t.clientX;
        startY.current = t.clientY;
        dx.current = 0;
        dy.current = 0;
        const edgeLimit = opts.startEdgeLeftPx ?? null;
        if (edgeLimit != null && startX.current > edgeLimit) {
            active.current = false;
            return;
        }
        active.current = true;
        // debug log removed
    };
    const onTouchMove = (e) => {
        if (!active.current || e.touches.length !== 1)
            return;
        const t = e.touches[0];
        dx.current = t.clientX - startX.current;
        dy.current = t.clientY - startY.current;
    };
    const onTouchEnd = (e) => {
        if (!active.current)
            return;
        active.current = false;
        try {
            // Compute final delta using end coordinates to avoid needing touchmove for simple gestures
            const t = e.changedTouches && e.changedTouches[0];
            if (t) {
                dx.current = t.clientX - startX.current;
                dy.current = t.clientY - startY.current;
            }
        }
        catch { }
        const absX = Math.abs(dx.current);
        const absY = Math.abs(dy.current);
        // debug log removed
        // Horizontal swipe
        if (absX > absY && absX > threshold) {
            if (dx.current < 0) {
                opts.onLeft?.();
            }
            else {
                opts.onRight?.();
            }
            return;
        }
        // Vertical swipe (down)
        if (absY > absX && absY > threshold) {
            if (dy.current > 0) {
                if (opts.requireTopForDown) {
                    let atTop = false;
                    try {
                        if (typeof opts.isAtTop === 'function') {
                            atTop = !!opts.isAtTop();
                        }
                        else {
                            const y = typeof window !== 'undefined' ? (window.scrollY || (document.documentElement?.scrollTop ?? 0)) : 0;
                            atTop = y <= 2;
                        }
                    }
                    catch {
                        atTop = false;
                    }
                    // debug log removed
                    if (atTop) {
                        opts.onDown?.();
                    }
                }
                else {
                    opts.onDown?.();
                }
            }
            else {
                opts.onUp?.();
            }
        }
    };
    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    };
}
